import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {Model} from '../class/model';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {RoleDataService} from '../role-service/data.service';
import {RoleJsPlumbService} from '../role-service/jsPlumb.service';
import {Schema} from '../class/schema';
import {Data} from '../class/data';
import {AccountInfoService} from '../../user/account-info.service';

declare let $;
declare let jsPlumb: any;

@Component({
    selector: 'app-role-model',
    templateUrl: './role-model.component.html',
    styleUrls: ['./role-model.component.scss']
})
export class RoleModelComponent {

    @Input() myModel: Model;
    @Input() masterRole: string;
    @Input() signInEmail: any;
    @Input() inputPartner: any;
    @Input() inputDataService: any;
    @Input() userExcludedPermissions: any;
    @Input() inputJsPlumbService: any;
    @Output() onDragStopped: EventEmitter<any> = new EventEmitter<any>();
    @Output() onDeletingModel: EventEmitter<any> = new EventEmitter<any>();
    @Output() onDeletingPermission: EventEmitter<any> = new EventEmitter<any>();
    @Output() onChangingLayout: EventEmitter<any> = new EventEmitter<any>();
    @Output() attachPermissionGroup: EventEmitter<any> = new EventEmitter<any>();
    @Output() attachPermission: EventEmitter<any> = new EventEmitter<any>();
    @Output() attachRole: EventEmitter<any> = new EventEmitter<any>();

    private bsModalRef: BsModalRef;
    public data: Data;
    model: any;
    models = [];
    dataId: any;

    constructor(public dataService: RoleDataService,
                public jsPlumbService: RoleJsPlumbService,
                public accountInfoService: AccountInfoService,
                public platform: LeftpanelComponent) {
    }


    ngOnInit() {
        this.dataId = 'schema' + this.myModel.getElementId();
        this.dataService = this.inputDataService;
        this.jsPlumbService = this.inputJsPlumbService;
    }

    ngAfterViewInit() {
        if (this.myModel.previewBlock) {
            //this.jsPlumbService.initModel(this.myModel);
            //$(this.myModel.getElementId()).css('z-index', 7);
            //this.jsPlumbService.initPreviewBlock(this.myModel.getElementId());
        }


        if (this.myModel.name === 'Permission Groups') {
            document.getElementById(this.myModel.getElementH2Id()).style.backgroundColor = '#2E8BF0';
            if (this.userExcludedPermissions && this.myModel.type !== 'Exclusions') {
                //console.log(this.userExcludedPermissionGroups);
                for (const model of this.myModel.childModels) {
                    let count = 0;
                    for (const permission of model.schemas) {
                        if (this.userExcludedPermissions.includes(permission.name)) {
                            count = count + 1;
                        }
                    }
                    if (count === model.schemas.length) {
                        const excludedDiv = document.getElementById(model.getElementH2Id());
                        if (excludedDiv) {
                            excludedDiv.style.backgroundColor = 'lightgray';
                            excludedDiv.style.color = 'black';
                            excludedDiv.style.fontWeight = 'bolder';
                            excludedDiv.style.textDecoration = 'line-through';
                            excludedDiv.style.opacity = '0.5';
                        }
                    }
                }
            }
        }
        if (this.myModel.name === 'Permissions' || this.myModel.type === 'permission') {
            document.getElementById(this.myModel.getElementH2Id()).style.backgroundColor = '#4BA89D';
            if (this.userExcludedPermissions && this.myModel.type !== 'Exclusions') {
                for (const permission of this.myModel.schemas) {
                    if (this.userExcludedPermissions.includes(permission.name)) {
                        const excludedDiv = document.getElementById(permission.getElementId());
                        if (excludedDiv) {
                            excludedDiv.style.textDecoration = 'line-through';
                        }
                    }
                }
            }
        }
        if (this.myModel.name === 'Roles') {
            document.getElementById(this.myModel.getElementH2Id()).style.backgroundColor = '#F09E27';
        }
        if (this.myModel.name === 'Exclusions') {
            document.getElementById(this.myModel.getElementH2Id()).style.backgroundColor = '#CA2121';
        }
        if (this.myModel.type === 'permissionGroup') {
            document.getElementById(this.myModel.getElementH2Id()).style.backgroundColor = '#58A1F0';
        }
        if (this.myModel.type === 'role' && this.myModel.getElementId() !== 'model1') {
            document.getElementById(this.myModel.getElementH2Id()).style.backgroundColor = '#7A7B83';
        }
        // if (this.myModel.previewBlock) {
        //     $('#' + this.myModel.getElementId()).addClass('example-box');
        // }
        this.myModel.schema_id_for_relation = Number(this.myModel.schema_id_for_relation);
        this.dataService.flg_repaint = true;
        //this.jsPlumbService.repaintEverything();
    }

    ngOnDestroy() {
        //this.jsPlumbService.destroyModel(this.myModel);
    }


    private editModel(): void {
        // this.bsModalRef = this.bsModalService.show( ModalModelComponent, {initialState:{
        //   mode: 'edit',
        //   model: this.myModel,
        //   use_laravel_auth: this.dataService.data.use_laravel_auth
        // }});
    }


    toggleConnectionsVisibility(visibleModel, status) {
        this.jsPlumbService.toggleConnectionsVisibilityForNode(visibleModel, status);
        let conns = this.jsPlumbService.getAllConnections(visibleModel);
        for (const conn of conns) {
            let model = this.dataService.getModelByElementH2Id(conn);
            //model.pos_x = model.pos_x + (pos_x - this.myModel.pos_x);
            //let id = '#' + model.getElementId();
            //$(id).hasClass('in') ? $(id).removeClass('in') : $(id).addClass('in');
            if (document.getElementById(model.getElementId())) {
                if (status === 'show') {
                    document.getElementById(model.getElementId()).style.display = 'block';
                } else if (status === 'hide') {
                    document.getElementById(model.getElementId()).style.display = 'none';
                }
            }
            // if (document.getElementById(model.getElementId()).style.display === 'none') {
            //     document.getElementById(model.getElementId()).style.display = 'block';
            // } else if (document.getElementById(model.getElementId()).style.display === 'block') {
            //     document.getElementById(model.getElementId()).style.display = 'none';
            // }
            if (model) {
                this.toggleConnectionsVisibility(model, status);
            }
        }
    }

    expandData(ev) {
        let id = '#schema' + this.myModel.getElementId();
        //$(id).toggleClass('collapse', 'collapse in');
        //$(id).addClass('collapse');
        if ($(ev.target).hasClass('fa-chevron-down')) {
            this.toggleConnectionsVisibility(this.myModel, 'hide');
            setTimeout(() => {
                //if (this.myModel.type !== 'permissionGroup') {
                //this.onChangingLayout.emit();
                //}
            }, 2000);

        } else if ($(ev.target).hasClass('fa-chevron-up')) {
            this.toggleConnectionsVisibility(this.myModel, 'show');
            setTimeout(() => {
                //if (this.myModel.type !== 'permissionGroup') {
                //this.onChangingLayout.emit();
                //}
            }, 1000);
        }
        $(ev.target).toggleClass('fa-chevron-up fa-chevron-down');
        $(id).hasClass('in') ? $(id).removeClass('in') : $(id).addClass('in');

        //jsPlumb.collapseGroup('roleGroup');
    }

    expandPermissionGroup(ev, targetId) {
        let id = '#schema' + targetId;
        $(ev.target).toggleClass('fa-chevron-up fa-chevron-down');
        $(id).hasClass('in') ? $(id).removeClass('in') : $(id).addClass('in');
    }

    public deleteModel() {
        this.onDeletingModel.emit(this.myModel);
        //if (confirm('Want to delete ' + this.myModel.name + '?')) {
        //this.dataService.deleteModel(this.myModel.id);
        //}
    }

    deletePermissionGroup(model) {
        this.onDeletingModel.emit(model);
    }

    onDeletingSchema(schema) {
        this.onDeletingPermission.emit(schema);
    }

    public getCountOfChildren() {
        if (this.myModel.name === 'Permission Groups') {
            return this.myModel.childModels.length;
        } else if (this.myModel.name === 'Roles') {
            return this.jsPlumbService.getAllConnections(this.myModel).length;
        } else {
            return this.myModel.schemas.length;
        }
    }

    private addSchema(): void {
        var schema = new Schema();
        schema.parent_id = this.myModel.id;
        if (this.dataService.data.use_laravel_auth) {
            schema.nullable = true;
        }
        // this.bsModalRef = this.bsModalService.show( ModalSchemaComponent, {initialState:{
        //   mode: 'create',
        //   schema: schema,
        //   use_laravel_auth: this.dataService.data.use_laravel_auth,
        //   parent_model: this.myModel
        // }} );
    }

    public dropped(event): void {

    }

    drop(ev) {
        ev.preventDefault();
        if (ev.dataTransfer.getData('data')) {
            const data = JSON.parse(ev.dataTransfer.getData('data'));
            const connection = {
                source: this.myModel,
                target: data.entity
            };
            switch (data.type) {
                case 'permissionGroup':
                    if (this.myModel.name === 'Permission Groups') {
                        this.attachPermissionGroup.emit(connection);
                    }
                    break;
                case 'permission':
                    if (this.myModel.name === 'Permissions' || this.myModel.previewBlock) {
                        this.attachPermission.emit(connection);
                    }
                    break;
                case 'role':
                    if (this.myModel.name === 'Roles') {
                        this.attachRole.emit(connection);
                    }
                    break;
            }
        }

        //var data = ev.dataTransfer.getData("text");
        //ev.target.appendChild(document.getElementById(data));
    }

    allowDrop(ev) {
        ev.preventDefault();
    }

    drag(ev) {
        //this.style.opacity = '1';
        //ev.dataTransfer.setData("text", ev.target.id);
    }

    public addToDrag(draggableModel) {
        let conns = this.jsPlumbService.getAllConnections(draggableModel);
        for (const conn of conns) {
            let model = this.dataService.getModelByElementH2Id(conn);
            //model.pos_x = model.pos_x + (pos_x - this.myModel.pos_x);
            if (model) {
                // setTimeout(() => {
                //     jsPlumb.addToGroup('roleGroup', this.el.nativeElement.querySelectorAll('#' + model.getElementId())[0]);
                // }, 3000);
                this.jsPlumbService.addToDragSelection(document.getElementById(model.getElementId()));
                this.addToDrag(model);
            }

            //this.jsPlumbService.initModel(model);
            //this.jsPlumbService.toggleDraggable(model);
        }
    }

    getTrimmedName(role) {
        const trimmedName = role.split('=>');
        if (trimmedName && trimmedName.length) {
            return trimmedName[trimmedName.length - 1];
        }
    }

    public startDrag(): void {
        this.jsPlumbService.toggleDraggable(this.myModel);
        if (this.myModel.type === 'role') {
            this.models = this.dataService.getModelsByName('Roles');
            // jsPlumb.addGroup({
            //     el: this.el.nativeElement.querySelectorAll('#' + this.myModel.getElementId())[0],
            //     id: 'roleGroup'
            // });
        } else if (this.myModel.type === 'permissionGroup') {
            this.models = this.dataService.getModelsByName('Permission Groups');
        } else if (this.myModel.type === 'permission') {
            this.models = this.dataService.getModelsByName('Permissions');
            this.models = this.models.concat(this.dataService.getModelsByType('permissionGroup'));
        }
        this.addToDrag(this.myModel);
        //console.log(this.models);
        // for (const model of this.models) {
        //     document.getElementById(model.getElementId()).style.border = '2px dashed green';
        // }

    }

    public endDrag(): void {
        this.jsPlumbService.toggleDraggable(this.myModel);
        this.jsPlumbService.clearDragSelection();
        //let style_left = this.el.nativeElement.querySelectorAll('#' + this.myModel.getElementId())[0].style.left;
        //let style_top = this.el.nativeElement.querySelectorAll('#' + this.myModel.getElementId())[0].style.top;
        //this.myModel.pos_x = parseInt(style_left, 10);
        //this.myModel.pos_y = parseInt(style_top, 10);
        //this.onDragStopped.emit(this.myModel);
        for (const model of this.models) {
            if (document.getElementById(model.getElementId())) {
                document.getElementById(model.getElementId()).style.border = 'none';
            }

        }
        // let conns = this.jsPlumbService.getAllConnections(this.myModel);
        // for (const conn of conns) {
        //     let model = this.dataService.getModelByElementH2Id(conn);
        //     //model.pos_x = model.pos_x + (pos_x - this.myModel.pos_x);
        //     this.jsPlumbService.toggleDraggable(model);
        // }
        //this.data = this.dataService.data;
        //this.model = this.data.getModelByName('Permission Groups');
        // record position


        // let conns = this.jsPlumbService.getAllConnections(this.myModel);
        // for (const conn of conns) {
        //     let model = this.dataService.getModelByElementH2Id(conn);
        //     let style_left = this.el.nativeElement.querySelectorAll('#' + model.getElementId())[0].style.left;
        //     let style_top = this.el.nativeElement.querySelectorAll('#' + model.getElementId())[0].style.top;
        //     model.pos_x = parseInt(style_left, 10);
        //     model.pos_y = parseInt(style_top, 10);
        //     //model.pos_x = model.pos_x + (pos_x - this.myModel.pos_x);
        // }

    }

}
